// extracted by mini-css-extract-plugin
module.exports = {"piano":"Piano_piano__3dk9X","mainContainer":"Piano_mainContainer__390dZ"};